import { render, staticRenderFns } from "./availableUsdtBalanceDetail.vue?vue&type=template&id=548c3709&scoped=true&"
import script from "./availableUsdtBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./availableUsdtBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./availableUsdtBalanceDetail.vue?vue&type=style&index=0&id=548c3709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c3709",
  null
  
)

export default component.exports